var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"color":_vm.color,"size":_vm.backroundsize}},[_c('span',{class:'white--text text-' + _vm.textsize + ' text-uppercase'},[_vm._v(_vm._s(_vm.avatarText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }